import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Pagination from '../../../../shared/components/pagination'
import CONSTANT from '../../../../shared/constants/constant'
import markdamageMps from'./../markdamageMPS'
import TripServices from '../../../services/firstAndLastmilemanagement.service'
import { BasicSelect,MultiSelect } from 'vue-search-select';
import XLSX from 'xlsx';
import Util from './../../../../shared/util/util'
import DamagempsDetails from './DamageMPSDetails'
const moment = require('moment');
import HScroll from "@koas/v-hscroll";
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';
import Multiselect from 'vue-multiselect'


export default {
    name: 'markdamagempslisting',
    components: {
        VueElementLoading,
        Treeselect,
        CustomExpandableTable,
        Pagination,
        markdamageMps,
        TripServices,
        BasicSelect,
        DamagempsDetails,
        CryptoJS,
        Util,
		DatePicker,
        Multiselect
    },
    data: function() {
        return{
         isLoading: false,
         arrowscollcss: false,
         ShowDamageMPSImages:false,
         showmarkdamagemps:false,
         totalPage: 0,
         totalCount:0,
         offset:0,
         image:"",
         isImageLoading:false,
         expandableKey: 0,
         currentPage: 1,
         pageLimit:CONSTANT.PER_PAGE_DATA,
         tableColumn: ['AWB','MPS', 'Region', 'Current HubName','Origin HubName','MarkDamage HubName','Last OutScan HubName','MPS Status','Description','CreatedBy','CreatedDate','Action'],
         tableItems: [],
         mpsnumber:'',
         mpsArr:[],
         caption:"MPS Damage Image",
         imagearray:[],
         markdamagezonelist:[
          // { id:1, label:'East'},
          // { id:2, label:'West'},
          // { id:3, label:'North'},
          // { id:4, label:'South-1'},
          // { id:5, label:'South-2'},
          // { id:6, label:'Central'},
          // { id:7, label:'North East'},
          ],
        damagezone:null,
        hubname:null,
        DamageHubList:[],
        parentdata:{},
        parentDetails:'',
        viewDetails: false,
        isDetailsLoading:false,
        HubZoneId:'',
        HubZoneName:'',
        disableflag:false,
		shortcuts:false,
		shipmentDamagenDate: '',
      }
    },
    async mounted() {
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.defaultHubID = userdetail.hubID[0];
      await Promise.all([
        this.getHubList(),
        this.getHubDetails(),
      ])
      // this.scrollarrow();
    },
    methods: {
      isIntegerOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode == 13) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
    async scrollarrow(){
    var scrollHandle = 0,
        scrollStep = 5,
        parent = $("#container");

    //Start the scrolling process
    $(".panner").on("mouseenter", function () {
        var data = $(this).data('scrollModifier'),
            direction = parseInt(data, 10);

        $(this).addClass('active');

        startScrolling(direction, scrollStep);
    });

    //Kill the scrolling
    $(".panner").on("mouseleave", function () {
        stopScrolling();
        $(this).removeClass('active');
    });

    //Actual handling of the scrolling
    function startScrolling(modifier, step) {
        if (scrollHandle === 0) {
            scrollHandle = setInterval(function () {
                var newOffset = parent.scrollLeft() + (scrollStep * modifier);

                parent.scrollLeft(newOffset);
            }, 10);
        }
    }

    function stopScrolling() {
        clearInterval(scrollHandle);
        scrollHandle = 0;
    }

},
    async searchdamageMPS(){
      this.arrowscollcss = true;
	  this.currentPage = 1;
      this.offset = 0;
      this.getDamageMPSListing()
    },
	selectZone(selectedZone) {
		this.selectedzoneid = selectedZone.id;
		this.selectedzonelabel = selectedZone.label;
		this.HubZoneId = selectedZone.id;
		this.damagezone = selectedZone.id;
		this.hubname = null
		if (selectedZone.id != '' && selectedZone.id != undefined) {
			this.fetchHubDataZonewise();
		} else {
			this.$alertify.error("Zone Id Is Not Allowed", "Zone Id", "error");
		}
	},
	async fetchHubDataZonewise() {
		try {
			this.DamageHubList = []
			let hubDataList = []
			let tempArr = [];
			let inputPayload = {
				'id': this.selectedzoneid,
			}
			await TripServices.fetchHubDataZonewise(inputPayload).then(result => {
				if (result.data.code == 200) {
					hubDataList = result.data.data.data;
					hubDataList.forEach(element => {
						if (element.HubName) {
							tempArr.push({
								'value': element.HubID,
								'text': element.HubName,
							})
						}
					});
					//this.hubList = tempArr;
					this.DamageHubList = tempArr
				}
			})
		} catch (error) {
			this.isLoading = false;
			console.log(error)
		}
	},
    async getHubDetails(){
      try{
        this.isLoading = true
        let hubId = []
		let zoneDataList = []
		let tempArr = [];
        hubId.push(this.defaultHubID)
        let input = {
          HubID:hubId
        }
		
			let result = await TripServices.getZoneList()
			if(result.data.code == 200) {
				zoneDataList = result.data.states.data;
				zoneDataList.forEach(element => {
					if (element.hubzonename) {
						tempArr.push({
							'id': element.hubzoneid,
							'label': element.hubzonename,
						})
					}
				});
				this.markdamagezonelist = tempArr;
			}
		//else{
		//	let result = await TripServices.GetHubDetailsForDamageMarking(input)
		//	for (var i = 0; i < result.data.data.length; i++) {
		//	  this.markdamagezonelist.push({
		//		'id': result.data.data[i].HubZoneId,
		//		'label': result.data.data[i].HubZoneName
		//	  })
		//	}
		//	this.HubZoneId = result.data.data[0].HubZoneId
		//	this.damagezone = result.data.data[0].HubZoneId
		//}

        this.getDamageMPSListing()
      }catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    async getHubList(){
        try{
        //   this.hublist = []
          let input = {}
          let result = await  TripServices.GetHublist(input);
          let HubList = result.data.data.data;
        for (var i = 0; i < HubList.length; i++) {
          this.DamageHubList.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
          });
        }
        } catch(err){
         this.isLoading = false;
          console.log(err);
        }
      },
      selectHub(data){
        this.hubname = data;
      },
      async getCustomTableEvent(id) {
        try{
        if (id.actionType == "edit") {
          let input = {
            id: id.id,
          };
          this.isLoading = true
          let resultMPS = await TripServices.GetDamageMPSImages(input);
          this.isLoading = false
          if (resultMPS.data.code == 200) {
            this.parentdata = {
              mps: resultMPS.data.data.mps,
              actionType: id.actionType,
            };
            this.showmarkdamagemps = true;
          } else {
            this.$alertify.error(resultMPS.data.message);
          }
        }
        if(id.actionType == "view"){
          this.viewDetails = false
          this.isDetailsLoading = true
          let input = {
            id:id.id
          };
          let result = await TripServices.GetDamageMPSImages(input);
            this.parentDetails ={
              mpsdetails: result.data.data.Reasons
            }
            this.isDetailsLoading = false
            this.viewDetails = true
        }
        if (id.actionType == "isviewimage") {
          this.imagearray = [];
          this.ShowDamageMPSImages = true;
          this.isImageLoading = true;
          let mpsId = id.id
          let input = {
            "id":mpsId
          };
          let resultImage = await TripServices.GetDamageMPSImages(input);
          if (resultImage.data.code == 200) {
            resultImage.data.data.damageimages.forEach((obj) => {
              this.imagearray.push(obj);
            });
          } else {
            this.imagearray = [];
          }
          this.isImageLoading = false;
        }
      }
      catch(err){
        this.isLoading = false
        console.log(err)
      }
      },
    async getDamageMPSListing(){
      try{
        this.isLoading = true
        let inputpayload = {
          "offset":this.offset,
          "limit":this.pageLimit,
        }
		if(this.damagezone){
			inputpayload.markdamagezone = this.damagezone
		}
        if(this.mpsnumber){
          this.mpsArr = (this.mpsnumber.split(','))
          inputpayload.mps = this.mpsArr
        }
        if(this.hubname ){
          inputpayload.markdamagehubid = this.hubname.value
        }
		if(this.shipmentDamagenDate[0]){
			inputpayload.damagedate = this.shipmentDamagenDate;
		}else{
			this.shipmentDamagenDate = []
		}
        let result = await TripServices.GetMPSDamageListing(inputpayload)
        if(result.data.code==200){
          this.tableArr = result.data.data.rows;
          this.totalCount = result.data.data.count;
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'AWB':el.awb,
              'MPS':el.mps,
              'Region':el.markdamagezonename,
              'Current HubName':el.currenthubname,
              'Origin HubName':el.originhubname,
              'MarkDamage HubName':el.markdamagehubname,
              'Last OutScan HubName':el.lastoutscanhubname == null ?'':el.lastoutscanhubname,
              'MPS Status':el.damagereason,
              'Description':el.description,
              'CreatedBy':el.createdby,
              'CreatedDate':moment.utc(el.createddate).format("DD-MM-YYYY HH:mm:ss"),
              'Action':""
            }
           })
           this.expandableKey += 1
        }
        else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
        this.scrollarrow();
      }catch(err){
        console.log(err)
        this.isLoading = false
      }
    },
    callParent() {
        this.showmarkdamagemps = false;
        this.parentdata = {}
        this.arrowscollcss = false;
        this.getDamageMPSListing()
      },
     changescrollcss(){
      var element = document.getElementById("collapse1").style.display;
      if(element == "none"){
        this.arrowscollcss = true;
      }else{

        this.arrowscollcss = false;
      }
     },
    clear(){
      this.currentPage = 1;
      this.offset = 0;
      this.damagezone = null,
      this.hubname = '',
      this.mpsnumber = '',
      this.mpsArr = [],
	  this.HubZoneId = '';
      this.markdamagezonelist = []
	  this.shipmentDamagenDate = ''
	  this.getHubList()
      this.getHubDetails()
    },
    markdamagempsfunction(){
        this.showmarkdamagemps = true

    },
    closeDamageMPSImages(){
        this.imagearray = []
        this.mps = ''
        this.reasonArr = []
        this.ShowDamageMPSImages =false;
      },
    async exportData(){
        try {
          this.isLoading = true;
          let inputPayload = {
            "markdamagezone" : this.HubZoneId
          }
          if(this.mpsnumber){
            this.mpsArr = (this.mpsnumber.split(','))
            inputPayload.mps = this.mpsArr
          }
            if(this.hubname){
            inputPayload.markdamagehubid = this.hubname.value
          }
		  if(this.shipmentDamagenDate[0]){
			inputPayload.damagedate = this.shipmentDamagenDate;
          }else{
			this.shipmentDamagenDate = []
		  }
          let result = await TripServices.GetMPSDamageListing(inputPayload)
          if(result.data.code==200){
            let tempdata = result.data.data.rows.map((el)=>{
              let images = []
              images.push(el.damageimages)
              return {
                'AWB':el.awb,
                'MPS':el.mps,
                'Region':el.markdamagezonename,
                'Current HubName':el.currenthubname,
                'Origin HubName':el.originhubname,
                'MarkDamage HubName':el.markdamagehubname,
                'Last OutScan HubName':el.lastoutscanhubname == null ?'':el.lastoutscanhubname,
                'MPS Status':el.damagereason,
                'Description':el.description,
                'CreatedBy':el.createdby,
                'CreatedDate':moment(el.createddate).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')
              }
             })
             let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
            const data = XLSX.utils.json_to_sheet(tempdata);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, 'data')
            XLSX.writeFile(wb,dt+'Damage_MPS_Data.xlsx');
          }else{
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
        } catch(err){
          console.log(err);
          this.isLoading = false;
        }
    },
    onPageChange(page) {
        this.currentPage = page;
        this.offset = (page - 1) * this.pageLimit
        this.getDamageMPSListing()
    },
    openImage(image) {
      this.image = image
      this.$nextTick(() => {
        let modal = document.getElementById('myModalImg' + image);
        var img = document.getElementById('imgid' + image);
        var modalImg = document.getElementById("img" + image);
        var captionText = document.getElementById("captionImg" + this.caption);
        modal.style.display = "block";
        modalImg.src = image;
        captionText.innerHTML = this.caption;
        this.ShowDamageMPSImages =false;
			})
    },
    closemodal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.ShowDamageMPSImages =true;
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/DamageMPS/markdamageMPSListing/markdamageMPSListing.component.js